import { defineMessages } from "react-intl";
const messages = defineMessages({
    availableUnitsTitle: {
        id: "app.sgt.tabs.availableUnits.title",
        defaultMessage: "Available Units",
    },
    unavailableUnitsTitle: {
        id: "app.sgt.tabs.unavailableUnits.title",
        defaultMessage: "Unavailable Units",
    },
    sgtSchedulesTitle: {
        id: "app.sgt.sgtTabs.schedules.text",
        defaultMessage: "Schedule",
    },
    sgtAccessDevicesTitle: {
        id: "app.sgt.sgtTabs.accessDevices.text",
        defaultMessage: "Access Devices",
    },
    availableUnitsSearchPlaceholder: {
        id: "app.sgt.availableUnits.search.placeholder",
        defaultMessage: "Search unit",
    },
    unavailableUnitsSearchPlaceholder: {
        id: "app.sgt.unavailableUnits.search.placeholder",
        defaultMessage: "Search unit",
    },
    accessDevicesSearchPlaceholder: {
        id: "app.sgt.accessDevices.search.placeholder",
        defaultMessage: "Search device",
    },
});
export default messages;
